import { Stomp } from 'stompjs/lib/stomp';
import { SESSION_ID } from '../../config/session-id';
import { Module } from './module';

Module.service('WebSocket', WebSocket);

/** @ngInject */
function WebSocket($rootScope) {

    const { url } = window.env.websocket;
    let lastUsedAt = null;
    let client = null;
    let connecting = false;

    var CONNECTION_WINDOW = 120000; // 2 minutes
    var connectionTimer = null;

    return {
        connect,
        isConnected,
        isConnecting,
    };

    function connect() {
        lastUsedAt = new Date();

        if (isConnected() || isConnecting()) {
            return;
        }

        client = Stomp.client(url);
        client.debug = null;
        connecting = true;
        client.connect({}, onConnect, onError);
    }

    function isConnected() {
        return client ? client.connected : false;
    }

    function isConnecting() {
        return connecting;
    }

    function onConnect(frame) {
        connecting = false;

        connectionTimer = setTimeout(function() {
            client.disconnect(function() {
                $rootScope.$apply(() => $rootScope.$broadcast('websocket.disconnected'));
            });
        }, CONNECTION_WINDOW);

        client.subscribe(`/exchange/websocket-exchange/${SESSION_ID}`, onReceive);
        $rootScope.$apply(() => $rootScope.$broadcast('websocket.connected'));
    }

    function onError(frame) {
        connecting = false;
        console.error(frame);
        cleanTimer();
        $rootScope.$apply(() => $rootScope.$broadcast('websocket.disconnected'));
    }

    function cleanTimer() {
        if (connectionTimer) {
            clearTimeout(connectionTimer);
            connectionTimer = null;
        }
    }

    function onReceive(frame) {
        const {type, content} = JSON.parse(frame.body);
        $rootScope.$apply(() => $rootScope.$broadcast(`websocket.${type}`, content));
    }
}



// WEBPACK FOOTER //
// ./src/modules/reverse-ajax/web-socket.service.js